import useSWRMutation from "swr/mutation"

import { BaseApiErrorResponse, BaseApiResponse } from "./api-config"
import { withAuthClientFetcher } from "./base-fetchers"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

type InfoMessage = {
  idMessage: number
  readFlag: number
  deleteFlag: number
  visionFlag: number
  isConfirmedRATD?: number
}

type NotifyMessagesPayload = {
  infoMessages: InfoMessage[]
}

type NotifyMessagesServiceResponse = BaseApiResponse

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/

const notifyMessagesServiceEndpoint = "/inbox-ms/ms/inbox/notifyMessages"

/* -------------------------------------------------------------------------------------------------
 * fetcher
 * -----------------------------------------------------------------------------------------------*/

const notifyMessagesFetcher = async (
  _key: string,
  { arg }: { arg: NotifyMessagesPayload },
) => {
  const { infoMessages } = arg
  try {
    await withAuthClientFetcher<
      NotifyMessagesServiceResponse,
      BaseApiErrorResponse
    >({
      method: "POST",
      url: notifyMessagesServiceEndpoint,
      body: {
        infoMessages,
      },
    })
  } catch {}
}

/* -------------------------------------------------------------------------------------------------
 * hooks
 * -----------------------------------------------------------------------------------------------*/

const useNotifyMessagesMutation = () => {
  const {
    trigger: makeNotifyMessages,
    isMutating: isNotifyMessagesMutationLoading,
    ...rest
  } = useSWRMutation("notifyMessages", notifyMessagesFetcher)

  return { makeNotifyMessages, isNotifyMessagesMutationLoading, ...rest }
}

export { notifyMessagesFetcher, useNotifyMessagesMutation }
